import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { PluginPanelContainer } from './shared/PluginPanelContainer';
export function SidebarSlot() {
    return (_jsx(SidebarSlotRoot, { children: _jsx(Content, { className: "tv-ui-shiny-border", children: _jsx(PluginPanelContainer, { slotId: "sidebar" }) }) }));
}
const Content = styled.div `
    position: absolute;
    top: 0%;
    height: 100%;
    left: 0%;
    right: 1.5rem;
    overflow: hidden;

    background: var(--tv-ui-color-18);
    iframe {
        width: 100%;
        height: 100%;
        background: none;
    }
`;
const SidebarSlotRoot = styled.div `
    height: 100%;
    position: relative;
`;
